import { IN_TO_M } from '../constants';

export function getNodeInfo(product, heightSide) {
  const {
    width,
    height,
    depth,
    marginTop,
    marginBottom,
    marginLeft,
    marginRight,
    ignorePreOccupy,
  } = product;
  return {
    width: width * IN_TO_M - 0.01,
    height: (product[heightSide] || height || depth) * IN_TO_M - 0.01,
    marginTop: (marginTop || 0) * IN_TO_M,
    marginBottom: (marginBottom || 0) * IN_TO_M,
    marginLeft: (marginLeft || 0) * IN_TO_M,
    marginRight: (marginRight || 0) * IN_TO_M,
    ignorePreOccupy,
  };
}



// WEBPACK FOOTER //
// ./src/helper/config.js